import axios from 'axios';
import { BUSINESSES_URL, BUSINESS_ADMIN_HOST } from 'api/constants';
import { createErrorFromAxiosUserMessageError } from 'api/utilities';
import { GET_ALL_BUSINESS, GET_BUSINESS_DETAILS, OUTLET_URI } from './constant';

export function performGetAllBusiness(payload) {
  let { page, size } = payload;
  if (!page) page = 1;
  if (!size) size = 10;
  const reqURI = `${GET_ALL_BUSINESS}`;

  const data = {
    page,
    size,
    start_expiration_date: payload.startDate
      ? new Date(payload.startDate).toISOString()
      : null,
    end_expiration_date: payload.endDate
      ? new Date(payload.endDate).toISOString()
      : null,
    status: payload.status,
    q: payload.searchKeyword,
    invoice_number: payload.invoiceNumber,
    search_by: payload.searchBy,
  };

  return axios
    .get(reqURI, { params: data })
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetEmployeeSlotsLogs(payload) {
  const { businessId } = payload;
  let { employeeLogsPage, size } = payload;
  if (!employeeLogsPage) employeeLogsPage = 1;
  if (!size) size = 10;
  const reqURI = `${BUSINESSES_URL}/${businessId}/employees/logs?page=${employeeLogsPage}&size=${size}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetEmployeeSlots(payload) {
  const { businessId } = payload;
  let { page, size } = payload;
  if (!page) page = 1;
  if (!size) size = 99999;
  const reqURI = `${BUSINESSES_URL}/${businessId}/employees?page=${page}&size=${size}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performCreateEmployeeSlot(payload) {
  const { businessId } = payload;
  const reqURI = `${BUSINESSES_URL}/${businessId}/employees/slots`;

  return axios
    .post(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performUpdateEmployeeSlotIsRenewableStatus(payload) {
  const { businessId } = payload;
  const reqURI = `${BUSINESSES_URL}/${businessId}/employees/slots/renewable`;

  return axios
    .put(reqURI, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetBusinessDetails(payload) {
  const { businessId } = payload;
  const reqURI = `${GET_BUSINESS_DETAILS}/${businessId}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performPatchBusinessPackage(payload) {
  const { businessId } = payload;
  const reqURI = `${BUSINESSES_URL}/${businessId}/packages`;

  return axios
    .patch(reqURI, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetOutlets(payload) {
  const { businessId, page, size } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/outlets?page=${page}&size=${size}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performAddOutletSlot(payload) {
  const reqURI = `${OUTLET_URI}/slots`;
  const { businessId } = payload;

  const newPayload = { business_id: businessId };
  return axios
    .post(reqURI, newPayload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetDeviceLogs(payload) {
  const { businessId } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/device_logs`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetBillingHistory(payload) {
  const { businessId } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/invoices`;
  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performVoidInvoice(payload) {
  const { businessId, invoiceId, invoiceNumber } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/invoices/${invoiceId}/void`;

  return axios
    .post(reqURI, { invoice_number: invoiceNumber })
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetInvoiceFileUrl(payload) {
  const { businessId, invoiceId } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/invoices/${invoiceId}/file-url`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetInvoiceVoidLogs(payload) {
  const { businessId } = payload;
  let { page, size } = payload;
  if (!page) page = 1;
  if (!size) size = 10;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/invoices/void-logs?page=${page}&size=${size}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performUpdateOutletSubscriptions(payload) {
  const { businessId } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/outlets/update-subscription/bulk`;

  return axios
    .patch(reqURI, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetFeatureSubscriptions(payload) {
  const { businessId, page, size } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/features?page=${page}&size=${size}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performActivateFeatureSubscriptionsOutlet(payload) {
  const { businessId } = payload;
  const reqURI = `${GET_ALL_BUSINESS}/${businessId}/features/subscriptions`;

  return axios
    .patch(reqURI, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetOutletSlots(payload) {
  const { businessId } = payload;
  const reqURI = `${BUSINESS_ADMIN_HOST}/v1/${businessId}/outlets/slots`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performUpdateOutletSlots(payload) {
  const reqURI = `${BUSINESS_ADMIN_HOST}/v1/outlets/slots/bulk`;

  return axios
    .put(reqURI, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetOutletLogs(payload) {
  const { businessId, page, size } = payload;
  const reqURI = `${BUSINESSES_URL}/${businessId}/outlets/logs?page=${page}&size=${size}`;

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performUpdateOwnerPhone(payload) {
  const { businessId, phone } = payload;
  const reqURI = `${GET_BUSINESS_DETAILS}/${businessId}/owner/phone`;

  return axios.patch(reqURI, { phone }).catch(error => {
    return Promise.reject(createErrorFromAxiosUserMessageError(error));
  });
}

export function performUpdateBusinessEntityType(payload) {
  const { businessId, businessEntityType } = payload;
  const reqURI = `${GET_BUSINESS_DETAILS}/${businessId}/attributes`;

  return axios
    .patch(reqURI, { business_entity_type: businessEntityType })
    .catch(error => {
      return Promise.reject(createErrorFromAxiosUserMessageError(error));
    });
}
